import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hr12to24hr'
})
export class Hr12to24hrPipe implements PipeTransform {

  transform(value: any, type: any) {
    if (type == '12-24') {
      if (value && value != '') {
        var time: any = value;
        var hours = Number(time.match(/^(\d+)/)[1]);
        var minutes = Number(time.match(/:(\d+)/)[1]);
        var AMPM = time.match(/\s(.*)$/)[1];
        if (AMPM == "PM" && hours < 12) hours = hours + 12;
        if (AMPM == "AM" && hours == 12) hours = hours - 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;
        return sHours + ":" + sMinutes + ":00";
      } else {
        return '';
      }
    } else if (type == '24-12') {
      if (value && value != '') {
        var time: any = value;
        let hour = (time.split(':'))[0]
        let min = (time.split(':'))[1]
        let part = parseInt(hour) >= 12 ? 'pm' : 'am'; // Correction here
        if (parseInt(hour) == 0)
          hour = 12;
        min = (min + '').length == 1 ? `0${min}` : min;
        hour = hour > 12 ? hour - 12 : hour;
        hour = (hour + '').length == 1 ? `0${hour}` : hour;
        return `${hour}:${min} ${part}`
      } else{
        return '';
      }
    } else{
      return value;
    }
  }
  

}
